// The browser's location (web/main.js locate): asked once at start (centring the map if allowed), and again from the
// locate button. Only works over https or on localhost; on the tailnet's plain http the map stays on St. Pete.
import type { LatLng } from "../shared/rules";
import { setFindingYou, setUserLocation } from "../state/view";

export function locate(onFound?: (l: LatLng) => void) {
  if (!navigator.geolocation) { setFindingYou(false); return; }
  navigator.geolocation.getCurrentPosition((pos) => {
    const l = { lat: pos.coords.latitude, lng: pos.coords.longitude };
    setUserLocation(l);
    onFound?.(l);
  }, () => setFindingYou(false), { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 });
}
